export const BRAND = {
  name: "Polaris",
  role: "Comunicación & Gestión Integral",
  people: "Rosbelys Rondón & Javier Gómez",
  tagline: "Comunicación estratégica para conectar, posicionar y crecer.",
  pillars: ["Relaciones Públicas", "Marketing", "Soporte Ejecutivo"],
  calendly: "https://calendly.com/rosbelysrondon/30min",
  email: "info@polarishelper.com",
  whatsapp: "14077211579",
};

export const EXEC_SUPPORT = {
  overline: "Soporte Ejecutivo & Operaciones",
  title: "Executive Support & Project Coordination",
  desc: "Brindamos soporte operativo y administrativo para optimizar procesos, mejorar la organización y facilitar la ejecución de proyectos.",
  items: [
    "Coordinación ejecutiva",
    "Gestión de agenda",
    "Seguimiento de proyectos",
    "Organización de eventos",
    "Coordinación de equipos y proveedores",
  ],
};

export const CONTACT_SERVICES = [
  "Relaciones Públicas",
  "Marketing & Contenidos",
  "Soporte Ejecutivo",
  "Gestión Integral / Concierge",
  "Producción de Contenidos",
  "Comunicación Estratégica",
];

export const DIVISIONS = [
  {
    key: "business",
    name: "Polaris Business",
    desc: "Comunicación, posicionamiento y operaciones para empresas y profesionales.",
    items: ["Comunicación estratégica", "Marketing", "Relaciones públicas", "Soporte ejecutivo"],
  },
  {
    key: "family",
    name: "Polaris Family",
    desc: "Gestión personal y familiar para simplificar tu día a día.",
    items: ["Gestión personal y familiar"],
  },
  {
    key: "projects",
    name: "Polaris Projects",
    desc: "Proyectos especiales gestionados de principio a fin.",
    items: ["Eventos", "Lanzamientos", "Mudanzas internacionales", "Reubicaciones", "Trámites complejos"],
  },
];

export const FAMILY = {
  title: "Polaris Family Support",
  subtitle:
    "Apoyo personalizado para simplificar la vida diaria de profesionales, empresarios y familias ocupadas.",
  intro:
    "Ayudamos a gestionar tareas cotidianas, coordinar servicios y resolver necesidades operativas para que nuestros clientes puedan dedicar más tiempo a lo que realmente importa.",
  categories: [
    {
      title: "Gestión Administrativa Familiar",
      items: [
        "Domiciliación y seguimiento de pagos",
        "Gestión de servicios y suscripciones",
        "Organización documental",
        "Seguimiento de trámites",
      ],
    },
    {
      title: "Coordinación de Salud y Bienestar",
      items: [
        "Programación de citas médicas",
        "Coordinación con especialistas",
        "Seguimiento de calendarios médicos",
        "Gestión de documentación relacionada",
      ],
    },
    {
      title: "Coordinación del Hogar",
      items: [
        "Búsqueda y coordinación de proveedores",
        "Solicitud de presupuestos",
        "Seguimiento de servicios",
        "Resolución de incidencias domésticas",
      ],
    },
    {
      title: "Educación y Actividades",
      items: [
        "Coordinación de actividades escolares",
        "Gestión de inscripciones",
        "Seguimiento de calendarios académicos",
        "Organización de actividades extracurriculares",
      ],
    },
    {
      title: "Viajes y Movilidad",
      items: [
        "Planificación de viajes",
        "Reservas",
        "Coordinación logística",
        "Elaboración de itinerarios",
      ],
    },
  ],
};

export const HERO_MAIN = {
  overline: "Firma boutique · Concierge estratégico & gestión integral",
  image: "/polaris-group.png",
  imageAlt:
    "Polaris acompaña a ejecutivos, deportistas, familias y mascotas, guiados por la estrella polar",
};

export const APPROACH = {
  overline: "Our Approach",
  intro:
    "Cada proyecto es diferente, pero nuestro proceso siempre está orientado a generar claridad, organización y resultados.",
  steps: [
    {
      n: "01",
      name: "Discover",
      tagline: "Comenzamos escuchando.",
      desc: "Analizamos los objetivos, desafíos y oportunidades de cada cliente para comprender su contexto y definir prioridades.",
    },
    {
      n: "02",
      name: "Strategize",
      tagline: "Diseñamos un plan de acción alineado con los objetivos del proyecto.",
      desc: "Definimos mensajes clave, canales de comunicación, cronogramas y acciones específicas.",
    },
    {
      n: "03",
      name: "Execute",
      tagline: "Llevamos las ideas a la acción.",
      desc: "Coordinamos la implementación de estrategias, proyectos y actividades con enfoque en calidad, consistencia y cumplimiento.",
    },
    {
      n: "04",
      name: "Support",
      tagline: "Nos mantenemos cerca.",
      desc: "Acompañamos a nuestros clientes mediante seguimiento continuo, coordinación y soporte estratégico para garantizar una ejecución efectiva.",
    },
  ],
};

export const HERO = {
  overline: "Periodista · Locutora · Coach de Voz",
  title_a: "Tu voz tiene poder.",
  title_b: "Hagamos que se escuche.",
  subtitle:
    "Más de 20 años en periodismo, radio y producción de contenidos. Acompaño a profesionales, líderes y emprendedores a fortalecer su comunicación para conectar, posicionar y crecer.",
  image:
    "https://images.unsplash.com/photo-1655947717064-d856af599bd1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHx3b21hbiUyMHJhZGlvJTIwaG9zdCUyMG1pY3JvcGhvbmUlMjBwb2RjYXN0JTIwc3R1ZGlvfGVufDB8fHx8MTc4MTk0ODM2NXww&ixlib=rb-4.1.0&q=85",
};

export const PROBLEMS = [
  {
    title: "Falta de dirección",
    desc: "No tienes claridad sobre hacia dónde va tu negocio o proyecto y sientes que avanzas sin un plan definido.",
    fix: "Te ayudamos a definir el rumbo y trazar un plan estratégico claro.",
  },
  {
    title: "Poco tiempo, muchas responsabilidades",
    desc: "La carga operativa te consume y te impide enfocarte en lo que realmente impulsa tu crecimiento.",
    fix: "Nos encargamos de lo importante para que recuperes tu tiempo.",
  },
  {
    title: "Desorganización y falta de sistemas",
    desc: "Los procesos no están estructurados, la información se dispersa y todo depende de ti.",
    fix: "Creamos orden, sistemas y procesos que te dan control y eficiencia.",
  },
  {
    title: "Necesitas apoyo de confianza",
    desc: "Buscas un aliado estratégico que entienda tu visión, te represente y actúe como extensión de tu equipo.",
    fix: "Somos tu mano derecha para acompañarte y proteger tu tiempo y tu enfoque.",
  },
  {
    title: "Gestión personal y familiar",
    desc: "Las tareas del día a día te quitan tiempo y energía que podrías dedicar a tu bienestar y al de tu familia.",
    fix: "Organizamos y gestionamos lo que necesitas para simplificar tu vida y la de tu familia.",
  },
  {
    title: "Proyectos complejos que requieren coordinación",
    desc: "Lanzamientos, eventos, viajes o cambios importantes que necesitan planificación, seguimiento y ejecución impecable.",
    fix: "Coordinamos cada detalle para que tus proyectos se conviertan en resultados exitosos.",
  },
];

export const SERVICES = [
  {
    title: "Relaciones Públicas",
    desc: "Gestión de medios, vocería, reputación y posicionamiento estratégico de tu marca personal o proyecto.",
    tag: "PR",
  },
  {
    title: "Marketing & Contenidos",
    desc: "Estrategia de contenidos, redes y campañas que conectan con la audiencia correcta y generan resultados.",
    tag: "Growth",
  },
  {
    title: "Soporte Ejecutivo",
    desc: "Agenda, coordinación y operaciones del día a día para que te enfoques en lo que de verdad importa.",
    tag: "Ops",
  },
  {
    title: "Producción de Contenidos",
    desc: "Guiones, podcast, radio y proyectos de comunicación de principio a fin, con estándar profesional.",
    tag: "Media",
  },
  {
    title: "Comunicación Estratégica",
    desc: "Definimos tu mensaje, narrativa y plan para conectar, posicionar y crecer con coherencia.",
    tag: "Estrategia",
  },
];

export const STATS = [
  { value: "+20", label: "Años de experiencia" },
  { value: "Radio & TV", label: "Periodismo y locución" },
  { value: "+150", label: "Líderes y marcas acompañadas" },
  { value: "2", label: "Profesionales a tu servicio" },
];

export const TEAM = [
  {
    name: "Rosbelys Rondón",
    role: "Comunicaciones y Estrategia",
    bio: "Periodista, locutora y especialista en comunicación, marketing, relaciones públicas y desarrollo de contenidos. Cuenta con una amplia trayectoria liderando proyectos de comunicación corporativa, posicionamiento de marca y estrategias de visibilidad para empresas y profesionales.",
    bio2: "A través de su experiencia trabajando con empresas, emprendedores y organizaciones, ha ayudado a fortalecer su presencia, mejorar su comunicación y conectar de manera efectiva con sus audiencias.",
  },
  {
    name: "Javier Gómez",
    role: "Coordinación Ejecutiva y Relaciones Institucionales",
    bio: "Licenciado en Ciencias Políticas con experiencia en asistencia ejecutiva, relaciones institucionales, coordinación administrativa y gestión de proyectos. Ha desempeñado funciones de apoyo directo a presidencias corporativas, coordinación de eventos, seguimiento de procesos y atención de clientes e instituciones.",
    bio2: "Su experiencia incluye cargos en relaciones institucionales, recursos humanos, asistencia ejecutiva y control de gestión en importantes organizaciones públicas y privadas.",
  },
];

export const TESTIMONIALS = [
  "“Aprendí a usar mi voz con seguridad. Mis presentaciones cambiaron por completo.”",
  "“Por fin tengo una estrategia de comunicación clara y un equipo que la ejecuta.”",
  "“Su experiencia en medios se nota: nos posicionaron ante la prensa correcta.”",
  "“Profesionalismo y calidez humana. Recomiendo su coaching de voz al 100%.”",
  "“Pasamos de improvisar a comunicar con propósito. Resultados reales.”",
];

export const PLANS = [
  {
    key: "start",
    name: "Polaris Start",
    audience: "Para emprendedores y profesionales independientes",
    intro: "Lo esencial para ordenar tu comunicación y dar tus primeros pasos con apoyo experto.",
    popular: false,
    features: [
      "Reunión estratégica mensual",
      "Gestión básica de comunicación",
      "Supervisión de redes sociales",
      "Asistencia administrativa puntual",
      "Coordinación de reuniones y agenda",
      "Soporte por correo electrónico",
    ],
  },
  {
    key: "growth",
    name: "Polaris Growth",
    audience: "Para empresas en crecimiento",
    intro: "Una solución integral que combina comunicación, posicionamiento y soporte operativo.",
    popular: true,
    features: [
      "Estrategia de comunicación",
      "Gestión de redes sociales",
      "Desarrollo de contenido",
      "Relaciones públicas básicas",
      "Coordinación de proyectos",
      "Seguimiento de tareas y proveedores",
      "Reuniones periódicas de planificación",
    ],
  },
  {
    key: "executive",
    name: "Polaris Executive",
    audience: "Para líderes, empresarios y equipos directivos",
    intro: "Un servicio de acompañamiento estratégico y ejecutivo de alto nivel.",
    popular: false,
    features: [
      "Comunicación estratégica",
      "Relaciones públicas y posicionamiento",
      "Gestión de agenda ejecutiva",
      "Coordinación de proyectos especiales",
      "Organización de eventos y reuniones",
      "Preparación de voceros y presentaciones",
      "Soporte prioritario",
    ],
  },
  {
    key: "custom",
    name: "Polaris Custom",
    audience: "Soluciones a la medida",
    intro: "Proyectos especiales diseñados exactamente para lo que necesitas.",
    popular: false,
    features: [
      "Lanzamiento de marca",
      "Organización de eventos",
      "Campañas de relaciones públicas",
      "Producción de podcasts",
      "Comunicación interna",
      "Desarrollo de marca personal",
      "Entrenamiento de voceros",
    ],
  },
];

// Comparison matrix. Cell values: true (incluido), false (no incluido) or text.
export const COMPARISON = {
  plans: ["Start", "Growth", "Executive", "Custom"],
  rows: [
    { label: "Estrategia de comunicación", values: ["Básica", "Estrategia", "Avanzada", "A medida"] },
    { label: "Gestión de redes sociales", values: ["Supervisión", "Completa", true, "A medida"] },
    { label: "Desarrollo de contenido", values: [false, true, true, "A medida"] },
    { label: "Relaciones públicas y posicionamiento", values: [false, "Básicas", true, "Campañas"] },
    { label: "Coordinación de proyectos", values: [false, true, "Especiales", "A medida"] },
    { label: "Gestión de agenda", values: ["Reuniones", false, "Ejecutiva", "A medida"] },
    { label: "Seguimiento de tareas y proveedores", values: [false, true, true, "A medida"] },
    { label: "Asistencia administrativa", values: ["Puntual", true, true, "A medida"] },
    { label: "Organización de eventos", values: [false, false, true, true] },
    { label: "Preparación / entrenamiento de voceros", values: [false, false, true, true] },
    { label: "Producción de podcasts", values: [false, false, false, true] },
    { label: "Desarrollo de marca personal", values: [false, false, false, true] },
    { label: "Reuniones de planificación", values: ["Mensual", "Periódicas", true, "A medida"] },
    { label: "Soporte", values: ["Correo", "Periódico", "Prioritario", "A medida"] },
  ],
};
